import React, { useRef } from 'react';
import Editor from '@monaco-editor/react';
import { jsonSchema } from '../schemas/json-schema';

const MonacoJsonEditor = ({ val, onChange, disabled, isBlock }) => {
  const editorRef = useRef(null);

  const handleEditorDidMount = (editor) => {
    editorRef.current = editor;
  };

  const handleEditorChange = (value) => {
    try {
      JSON.parse(value);
    } catch (error) {
      return;
    }
    onChange(value);
  };

  const handleFormat = () => {
    if (editorRef.current) {
      editorRef.current.getAction('editor.action.formatDocument').run();
    }
  };

  const handleDelete = () => {
    onChange('');
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginBottom: '40px', marginTop: '20px' }}>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <button
          onClick={handleFormat}
          style={{
            padding: '5px 10px',
            color: '#32bc9b',
            cursor: 'pointer',
            width: '150px',
            alignSelf: 'center',
            marginBottom: '20px',
            background: 'none',
            border: '1px solid #32bc9b',
            borderRadius: '5px'
          }}
          disabled={disabled}
        >
          フォーマット
        </button>
        {isBlock && (
          <button
            onClick={handleDelete}
            style={{
              marginLeft: '10px',
              padding: '5px 10px',
              color: '#32bc9b',
              cursor: 'pointer',
              width: '150px',
              alignSelf: 'center',
              marginBottom: '20px',
              background: 'none',
              border: '1px solid #32bc9b',
              borderRadius: '5px'
            }}
            disabled={disabled}
          >
            削除
          </button>
        )}
      </div>
      <Editor
        height={val.split('\n').length * 20 + 'px'}
        defaultLanguage="json"
        value={val}
        onChange={handleEditorChange}
        onMount={handleEditorDidMount}
        theme="vs-dark"
        options={{
          minimap: { enabled: false },
          formatOnPaste: true,
          formatOnType: true,
          autoClosingQuotes: 'always',
          autoClosingBrackets: 'always',
          tabSize: 2,
          bracketPairColorization: { enabled: true },
          autoIndent: 'full',
          wordWrap: 'on',
          scrollBeyondLastLine: false,
          schemas: [{
            uri: 'http://myschema/json-schema.json',
            fileMatch: ['*'],
            schema: jsonSchema
          }]
        }}
        disabled={disabled}
      />
    </div>
  );
};

export default MonacoJsonEditor;
